import { render, staticRenderFns } from "./addCompanyInfo.vue?vue&type=template&id=0b614632&scoped=true&"
import script from "./addCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./addCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./addCompanyInfo.vue?vue&type=style&index=0&id=0b614632&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b614632",
  null
  
)

export default component.exports